module.exports = __webpack_public_path__ + "static/assets/84ffa571b532f01665cd95b4e5f77c36.svg";